/** Roles that may manage CMS ED facility data (manual placement, claim/challenge adjudication). */
// llm-manager-global is the owner-superuser surface — intentionally holds facility-data-admin capability. Do not remove without owner sign-off.
const FACILITY_DATA_ADMIN_ROLE_ENTRIES = [
  'chartmind-admin',
  'llm-manager-global',
  'system-medical-admin',
];

export const FACILITY_DATA_ADMIN_ROLE_LIST = Object.freeze([...FACILITY_DATA_ADMIN_ROLE_ENTRIES]);

export const FACILITY_DATA_ADMIN_ROLES = new Set(FACILITY_DATA_ADMIN_ROLE_ENTRIES);

/** Default owner digest inbox when users/{uid}.facilityDataDigestEmail is unset. */
export const DEFAULT_FACILITY_DATA_DIGEST_EMAIL = 'drsclaud@aol.com';

/**
 * @param {string | null | undefined} role Effective user role.
 * @returns {boolean}
 */
export function hasFacilityDataAdminCapability(role) {
  if (!role) return false;
  return FACILITY_DATA_ADMIN_ROLES.has(String(role).trim());
}
